import { render, staticRenderFns } from "./popular-products.vue?vue&type=template&id=0f2cabb8&scoped=true&"
import script from "./popular-products.vue?vue&type=script&lang=ts&"
export * from "./popular-products.vue?vue&type=script&lang=ts&"
import style0 from "./popular-products.vue?vue&type=style&index=0&id=0f2cabb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cabb8",
  null
  
)

export default component.exports